import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { DataService, HelperService, HTTPService } from 'app/services';
import { paymentTypes } from 'app/constants';
import { RefundPaymentDialogComponent } from 'app/modules/app-components/refund-payment-dialog/refund-payment-dialog.component';
import { currency } from 'app/constants/currency.constants';
import { ViewPaymentComponent } from 'app/modules/app-components/view-payment/view-payment.component';

@Component({
  selector: 'app-payment-option-dialog',
  templateUrl: './payment-option-dialog.component.html',
  styleUrls: ['./payment-option-dialog.component.scss'],
})
export class PaymentOptionDialogComponent implements OnInit {
  payment: any = {};
  icon: string = 'fa-money-check-alt';
  usd = currency.USD;
  refundStatus: number;
  isLoading: boolean;
  isLoadingCheckStatus: boolean = true;
  isShowPendingError: boolean = false;
  payrixData: any = {};
  refundAmout: any = '';
  isPurchased: boolean = false;
  isTransectionStatusDebit = false;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    public helperService: HelperService,
    private dialogService: DialogService,
    private dataService: DataService,
    private httpService: HTTPService
  ) {}

  ngOnInit() {
    const data = this.dialogConfig.data;

    this.isLoading = true;
    this.payment = data.payment;
    this.isPurchased = data.isPurchased;
    this.refundAmout = this.payment.amount - this.payment.refundToDate;

    // In case of payrix status check
    if (this.payment.payrixResponse?.data) {
      this.payrixData = this.payment.payrixResponse.data[0];
      this.payment.paymentTypePayrix = ` *${this.payment.card4Digits}`;

      if (this.refundAmout) {
        this.checkPayrixstatus();
      } else {
        this.isLoadingCheckStatus = false;
      }
    } else {
      // In case pf globalPay status check
      if (this.payment.globalPayResponse?.status && this.refundAmout) {
        this.checkglobalPaystatus();
      } else {
        // On manual payment
        this.payment.paymentTypePayrix = this.payment.card4Digits ? ` *${this.payment.card4Digits}` : ' ';
        this.isLoadingCheckStatus = false;
      }
    }

    paymentTypes.map((paymentType) => {
      if (paymentType.value === this.payment.paymentType) {
        this.icon = paymentType.icon;
      }
      this.isLoading = false;
    });
  }

  checkPayrixstatus() {
    this.payment.refundStatus = this.refundStatus;
    this.httpService.payrixcheckStatus(this.payment._id).then(
      (res: any) => {
        this.refundStatus = res.status;
        this.isLoadingCheckStatus = false;
      },
      (err) => {
        this.isShowPendingError = true;
        this.isLoadingCheckStatus = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  checkglobalPaystatus() {
    this.isLoadingCheckStatus = true;
    this.payment.refundStatus = this.refundStatus;
    this.httpService.globalPaymentcheckStatus(this.payment._id).then(
      (res: any) => {
        this.refundStatus = res.status;
        this.isTransectionStatusDebit = res.isDebit;
        this.isLoadingCheckStatus = false;
      },
      (err) => {
        this.isShowPendingError = true;
        this.isLoadingCheckStatus = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  openPaymentEditDialog(paymentId: string) {
    this.closeDialog();
    if (this.isPurchased) {
      this.dataService.sendData(
        this.dataService.typeDialog('add-purchase', 'payment-list', null, null, {
          paymentId,
          payment: this.payment,
        })
      );
      return;
    }
    this.dataService.sendData(
      this.dataService.typeDialog('add-payment', 'payment-list', null, null, {
        paymentId,
        payment: this.payment,
        isEditMode: true, //Fix for ALP-14635 Issue #4
      })
    );
  }

  openCreateRefundDialog(paymentId: string) {
    if (this.isShowPendingError) {
      this.helperService.showToaster(
        'error',
        `With Card swipe transactions, refunds from the app can only be processed after a day.
      Please try the refund from the terminal device`
      );
      return;
    }
    this.closeDialog();
    this.openRefundDialog(paymentId);
  }

  openViewPaymentDialog(paymentId: string) {
    this.closeDialog();
    this.dialogService.open(ViewPaymentComponent, {
      width: '70%',
      styleClass: 'add-dialog add-refund-modal edit-payment-fixed-width',
      showHeader: false,
      data: { paymentId, refundStatus: this.refundStatus, voidRefundAmount: (this.payment.amount || 0.0) - (this.payment.refundToDate || 0) },
    });
  }
  openRefundDialog(paymentId) {
    this.dialogService.open(RefundPaymentDialogComponent, {
      width: '70%',
      styleClass: 'add-dialog add-refund-modal edit-payment-fixed-width',
      showHeader: false,
      data: { paymentId, refundStatus: this.refundStatus, isTransectionStatusDebit: this.isTransectionStatusDebit, voidRefundAmount: (this.payment.amount || 0.0) - (this.payment.refundToDate || 0) },
    });
  }
  closeDialog() {
    this.isShowPendingError = false;
    this.dynamicDialogRef.close();
  }
}
